import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getRaioxProfessores(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/raiox/professores/', {params});
  return data;
}

type QueryFnType = typeof getRaioxProfessores;

function useRaioxProfessores(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-raiox-professores', params],
    queryFn: () =>  getRaioxProfessores(params),
  });
}

export { useRaioxProfessores };
